<template>
	<div class="lineup">
		<Tab
			v-if="participants[0] && participants[0].club"
			:tabs="participants"
			data-qa="teams"
			small
		>
			<template #tabs-menu="{ selected, selectTab }">
				<ul
					class="tabs-menu"
					data-qa="tabs"
				>
					<li
						v-for="participant in participants"
						:key="`participant-${participant.key}`"
						class="tabs-menu__item"
						:class="{
							'active': participant.key === selected,
						}"
						@click="selectTab(participant.key)"
					>
						<div
							v-if="participant.label"
							class="team-identity"
						>
							{{ participant.label }}
						</div>
					</li>
				</ul>
			</template>
			<template
				v-for="(participant, idx) in participants"
				:slot="`tab-details-${participant.key}`"
			>
				<LineupTable
					:key="`${participant.id}${idx}`"
					:players="participant.players"
					:table-header="tableHeader"
					@item-click="(player) => openPlayerDetails(player)"
				/>
			</template>
		</Tab>
		<div v-else>
			<LineupTable
				:table-header="tableHeader"
				:players="participants"
				@item-click="(player) => openPlayerDetails(player)"
			/>
		</div>
	</div>
</template>

<script>
import Tab from '@components/tab';
import LineupTable from './LineupTable';

export default {
	name:       'Lineup',
	components: { LineupTable, Tab },
	props:      {
		participants: {
			type:    Array,
			default: () => [],
		},
		tableHeader: {
			type:    Object,
			default: () => {},
		},
	},
	methods: {
		openPlayerDetails(player) {
			this.$emit('open-player-details', player);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.lineup {
	height: 100%;
	color: var(--color-soft-white);
	overflow-y: auto;

	body.-t-light & {
		color: var(--color-black);
	}
}

.tabs-menu {
	margin-top: 12px;
	margin-bottom: 12px;

	&:not(.is-tagging-tool) {
		li {
			color: var(--color-grey-300);
			border-bottom: none;
			padding: 6px 16px 6px 16px;
			margin-right: 8px;
			border-radius: 2px;

			.team-identity {
				display: flex;
				align-items: center;
				@include text-sm-2;

				img {
					border-radius: 50%;
					margin-right: 12px;
					width: 24px;
				}
			}

			&:hover:not(.active) {
				background: var(--color-grey-950);
			}
		}

		.active {
			color: var(--color-soft-white);
			background: var(--color-grey-900);

			body.-t-light & {
				background: var(--color-hype-yellow);
			}
		}
	}
}

.tabs-menu__item {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

</style>
